import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";

// The effective primary recipient for a multi-recipient email: the user's explicit
// pick when it is still among the recipients, otherwise the first recipient (which
// matches the server's default when no primaryContactId is sent).
const resolvePrimaryEmailRecipientId = (
  recipients: Pick<EntitiesSupportedByEmailFeature, "id">[],
  selectedPrimaryId: EntitiesSupportedByEmailFeature["id"] | undefined
): EntitiesSupportedByEmailFeature["id"] | undefined => {
  if (!recipients.length) {
    return undefined;
  }
  const selectedIsRecipient =
    selectedPrimaryId != null && recipients.some((recipient) => recipient.id === selectedPrimaryId);
  return selectedIsRecipient ? selectedPrimaryId : recipients[0].id;
};

export default resolvePrimaryEmailRecipientId;
